(function ($) {
  $(document).ready(function () {
    if ($(".news-carousel").length > 0) {
      getClass("news-carousel");

      function getClass(sectionclass) {
        $("." + sectionclass).addClass(sectionclass + "-view");
        var className = $(
          "." + sectionclass + " .views-element-container > div"
        ).attr("class");
        removeDIV("." + className);
        removeDIV("." + sectionclass + " .views-element-container");
      }
      function removeDIV(DivClass) {
        var cnt = $(DivClass).contents();
        $(DivClass).replaceWith(cnt);
      }
      setTimeout(function () {
        $(".news-carousel .news-slider").css({ opacity: "1" });
      }, 500);

      $(".news-carousel .news-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              draggable: true,
            },
          },
          {
            breakpoint: 595,
            settings: {
              slidesToShow: 1,
              draggable: true,
            },
          },
        ],
      });
        
    }

    $(".news-carousel.publication-detail .news-slider").slick("unslick");


  });
})(jQuery);
